<template>
  <div class="tw-mx-4 tw-py-4">
    <div class="tw-grid tw-grid-cols-10 tw-gap-5">
      <div class="tw-col-span-2 tw-space-y-3">
        <GameSearchFilters></GameSearchFilters>
      </div>
      <div class="tw-col-span-8">
        <CasinoTabs :casinoProviders="casinoProviders" @onGoToCasino="goToCasino"></CasinoTabs>

        <v-card color="#031b41" class="tw-col-span-5">
          <v-card-title>Game List Display</v-card-title>
          <GameListDisplay></GameListDisplay>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import GameSearch from "../../components/GameSearch.vue";
import GameSearchFilters from "../../components/GameSearchFilters.vue";
import draggable from "vuedraggable";
import CasinoTabs from "../../components/admin/CasinoTabs.vue";
import GameList from "../../components/admin/AdminCasinoManager/GameList.vue";
import GameListDisplay from "../../components/admin/AdminCasinoManager/GameListDisplay.vue";
export default {
  props: ["casinoProviders"],
  components: {
    draggable,
    GameSearch,
    GameSearchFilters,
    CasinoTabs,
    GameList,
    GameListDisplay,
  },
  data() {
    return {
      tab: 0,
      filter: [],
      provider: [],
      filtered_item: "",
      selected_provider: "",
    };
  },

  methods: {
    goToCasino(provider) {
      if (provider == "Casino Games") {
        return this.$router.push("/admin/casino-games");
      }
      this.$router.push({
        path: "/admin/games",
        query: { casinoprovider: provider },
      });
    },
  },
};
</script>

<style>
.v-text-field__details {
  display: none !important;
}
.theme--dark.v-list {
  background-color: #031b41 !important;
}
</style>
